import React, { useEffect, useState } from 'react';
import LoginPage from './LoginPage';
import {AES, enc} from 'crypto-js';
import awsconfigDEV from '../../awsconfiguration-dev.json';



const QrLoginPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [schoolId, setSchoolId] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.split('?')[1]);
    const passkey = awsconfigDEV.Decrypt.passkey
    setUsername(JSON.parse(AES.decrypt(params.get('u').replace(/ /g, "+"), passkey).toString(enc.Utf8)).password)
    setPassword(JSON.parse(AES.decrypt(params.get('p').replace(/ /g, "+"), passkey).toString(enc.Utf8)).password)
    setSchoolId(JSON.parse(AES.decrypt(params.get('s').replace(/ /g, "+"), passkey).toString(enc.Utf8)).password)
    setLoading(false) 
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }
  else{
    return <LoginPage schoolId={schoolId} username={username} password={password}/>
  }

};

export default QrLoginPage;
